import React, { Component } from 'react'
import { renderReact } from 'hypernova-react'

// I18n
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ru from 'react-intl/locale-data/ru'
import zh from 'react-intl/locale-data/zh'
import ja from 'react-intl/locale-data/ja'
import localeData from './locales/data'

addLocaleData([...en, ...ru, ...zh, ...ja])

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

// Components
import Layout from './layout'
import Login from './auth/login'
import Register from './auth/register'
import ActivationCode from './auth/activation_code'

class Auth extends Component {
  constructor(props) {
    super(props)

    let flash = null
    if (props.flash && props.flash.length > 0) {
      const [type, message] = props.flash[0]
      flash = { type, message }
    }

    const { activationCode, login, continueRegistration } = props

    let component = continueRegistration === 'true' ? 'Register' : 'Login'
    if (props.component) {
      component = props.component
    } else if (props.isOnnet) {
      // component = 'Register'
      flash = {
        type: 'notice',
        message: localeData[props.intlLocale]['Login.TryLogin'],
      }
    }

    if (props.login && component === 'Login') {
      flash = {
        type: 'notice',
        message: localeData[props.intlLocale]['ActivationCode.AlreadyHasCards'],
      }
    }

    // component = 'Register'
    this.state = {
      component,
      activationCode: activationCode || '',
      simcardRegion: null,
      flash,
      email: '',
      phone: '',
      login: login || '',
    }

    this.changeComponent = this.changeComponent.bind(this)
    this.flashHandler = this.flashHandler.bind(this)
    this.loginNextStep = this.loginNextStep.bind(this)
    this.changeLogin = this.changeLogin.bind(this)
  }

  changeActivationCodeHandler(activationCode) {
    this.setState({ activationCode })
  }

  changeLogin(value) {
    const login = value.replace(/\s/g, '')
    this.setState({ login })
  }

  regionHandler(simcardRegion) {
    if (this.props.region === simcardRegion) {
      this.changeComponent('Register')
    } else {
      this.innerRedirect(simcardRegion)
    }
    this.setState({ simcardRegion })
  }

  innerRedirect(simcardRegion) {
    const continueParam = simcardRegion ? '&continue_registration=true' : ''
    const login = encodeURIComponent(this.state.login)
    const { activationCode } = this.state

    window.location = `/login?activation_code=${activationCode}&login=${login}${continueParam}`
  }

  accountExistsHandler(email, phone, flash) {
    this.setState({
      flash,
      email,
      phone
    }, this.changeComponent('Login'))
  }

  renderComponent() {
    switch (this.state.component) {
      case 'Login':
        return this.renderLogin()
      case 'ActivationCode':
        return this.renderActivationCode()
      case 'Register':
        return this.renderRegister()
    }
  }

  changeComponent(component) {
    this.setState({ component, flash: null })
  }

  flashHandler(flash) {
    this.setState({ flash })
  }

  loginNextStep() {
    if (this.props.isOnnet) {
      this.changeComponent('Register')
    } else {
      this.changeComponent('ActivationCode')
    }
  }

  renderLogin() {
    const { email, phone, activationCode, login } = this.state
    const { locale, intlLocale, region } = this.props
    const messages = localeData[intlLocale]

    return (
      <Login
        locale={locale}
        messages={messages}
        intlLocale={intlLocale}
        token={this.props.token}
        nextStep={this.loginNextStep}
        region={region}
        activationCode={activationCode}
        email={email}
        phone={phone}
        login={login}
        flashHandler={this.flashHandler}
      />
    )
  }

  renderActivationCode() {
    const { locale, intlLocale, region } = this.props
    const { login } = this.state
    const messages = localeData[intlLocale]

    return (
      <ActivationCode
        locale={locale}
        messages={messages}
        intlLocale={intlLocale}
        changeHandler={this.changeActivationCodeHandler.bind(this)}
        activationCode={this.state.activationCode}
        regionHandler={this.regionHandler.bind(this)}
        // region='cn'
        region={region}
        changeLogin={this.changeLogin.bind(this)}
        innerRedirect={this.innerRedirect.bind(this)}
        login={login}
      />
    )
  }

  renderRegister() {
    const { activationCode, login } = this.state
    const { locale, intlLocale, region, token, iccid } = this.props
    const messages = localeData[intlLocale]

    return (
      <Register
        locale={locale}
        messages={messages}
        intlLocale={intlLocale}
        // region='cn'
        region={region}
        renderLogin={() => { this.changeComponent('Login') }}
        token={token}
        accountExistsHandler={this.accountExistsHandler.bind(this)}
        activationCode={activationCode}
        iccid={iccid}
        login={login}
        setFlash={this.flashHandler}
        onnet={this.props.isOnnet}
      />
    )
  }

  render() {
    const { intlLocale, locale, region } = this.props
    const messages = localeData[intlLocale]

    return (
      <IntlProvider locale={intlLocale} intlLocale={intlLocale} messages={messages}>
        <Layout
          locale={locale}
          intlLocale={intlLocale}
          messages={messages}
          region={region}
          flash={this.state.flash}
          resources={this.props.resources}
        >
          {this.renderComponent()}
        </Layout>
      </IntlProvider>
    )
  }
}

export default renderReact('application/auth', Auth)



// WEBPACK FOOTER //
// ./app/javascript/components/application/auth.js